export default {
    '0911': [
        {'Query': '石景山科技馆', 'City': '北京', 'Answer': '石景山科技馆'},
        {'Query': '玉渊潭附近美食', 'City': '北京', 'Answer': '柴氏风味斋（甘家口总店）'},
        // {'Query': '温泉会所', 'City': '北京', 'Answer': '温泉四合院'},
        {'Query': '成都川菜排名', 'City': '成都', 'Answer': '耍酒馆（金牛店）'},
        {'Query': '儿童自由搏击', 'City': '北京', 'Answer': '晟宇搏击俱乐部'},
        {'Query': '金都路918号', 'City': '上海', 'Answer': '忻语咖啡'},
        {'Query': '附近的修鞋店', 'City': '上海', 'Answer': '嘉泰擦鞋店'},
        {'Query': '火锅排行榜', 'City': '成都', 'Answer': '巴蜀大宅门火锅（清江东路店）'},
        {'Query': '理发店剪发', 'City': '深圳', 'Answer': '首脑丝情美发沙龙（阳光里店）'},
        {'Query': '日本料理', 'City': '上海', 'Answer': '山里日本料理'},
        {'Query': '自行车', 'City': '北京', 'Answer': 'GIANT（酒仙桥店）'},
        {'Query': '日料', 'City': '天津', 'Answer': '汐竹家料理寿司吧（天河城店）'},
        {'Query': '卤煮', 'City': '北京', 'Answer': '小肠陈卤煮（草桥店）'},
        {'Query': '麻辣香锅', 'City': '杭州', 'Answer': '汉库麻辣香锅（紫金港店）'},
        {'Query': '海鲜烧烤', 'City': '上海', 'Answer': '大成海鲜烧烤（虹桥店）'},
        {'Query': '幼儿园', 'City': '上海', 'Answer': '天池幼儿园'},
        {'Query': '北京路美食', 'City': '广州', 'Answer': '小炳胜（北京路店）'},
        {'Query': '亚运村附近美食', 'City': '北京', 'Answer': '宸悦·新派湘粤菜'},
        {'Query': '天目湖鱼头', 'City': '上海', 'Answer': '天目山农庄（国顺东路店）'},
        {'Query': '儿童摄影', 'City': '北京', 'Answer': '儿时蒙太奇摄影高级手绘定制（亦庄店）'},
        {'Query': '早茶排行榜', 'City': '深圳', 'Answer': '点都德（kk one店）'},
        {'Query': '手擀面', 'City': '天津', 'Answer': '八爷手擀炸酱面'},
        {'Query': '漕宝路日月光', 'City': '上海', 'Answer': '星巴克（徐汇日月光店）'},
        {'Query': '客栈', 'City': '深圳', 'Answer': '花房精品客栈'},
        {'Query': '造型', 'City': '上海', 'Answer': '南瓜车造型（汇金店）'},
        {'Query': '牛肉火锅', 'City': '深圳', 'Answer': '潮汕大目牛肉火锅城（南山枫叶店）'},
        {'Query': '食品厂', 'City': '上海', 'Answer': '哈尔滨食品厂（汇金百货店）'},
        {'Query': '银饰diy', 'City': '上海', 'Answer': '慢生活银饰珍珠DIY工作室'},
        {'Query': '烤肉', 'City': '天津', 'Answer': '超级神炭烤肉夜食（三马路店）'},
        {'Query': '东陆路美食', 'City': '上海', 'Answer': '大城小厨（莱阳路店）'},
        {'Query': '美发', 'City': '北京', 'Answer': '文峰美发美容（望京广顺南街32店）'},
        {'Query': '滨江大道2450号', 'City': '上海', 'Answer': '海逸逸荟（滨江店）'},
        {'Query': '蛋糕 生日蛋糕', 'City': '天津', 'Answer': '杜夫朗格蛋糕（大悦城店）'},
        {'Query': '户外自助烧烤', 'City': '北京', 'Answer': '十渡馋眠主题民宿小院农家院'},
        {'Query': '摄影馆', 'City': '北京', 'Answer': '大熊baby摄影馆（四季青桥店）'},
        {'Query': '日式烤肉', 'City': '北京', 'Answer': '伙伴日式烤肉'},
        {'Query': '野生动物园', 'City': '北京', 'Answer': '北京野生动物园'},
        {'Query': '手工吐司', 'City': '上海', 'Answer': '爸爸糖手工吐司（金沙江路店）'},
        {'Query': '酒店面包', 'City': '北京', 'Answer': 'Le Grenier a pain正本原'},
        {'Query': '蒸汽石锅鱼', 'City': '北京', 'Answer': '鲜潭蒸汽石锅鱼（国瑞购物中心店）'},
        {'Query': '烧烤', 'City': '上海', 'Answer': '唐苑新疆烧烤王·巫山烤全鱼（广灵店）'},
        {'Query': '外滩下午茶露台', 'City': '上海', 'Answer': 'THE BALFOUR 外滩源壹号'},
        {'Query': '金融街购物中心附近美食', 'City': '北京', 'Answer': '云海肴云南菜（金融街购物中心店）'},
        {'Query': '日本神户牛肉', 'City': '上海', 'Answer': 'SUSHI YANG'},
        {'Query': 'spa', 'City': '上海', 'Answer': '雅泰SPA足道会馆（共康路店）'},
        {'Query': '酒店', 'City': '成都', 'Answer': '成都首座万丽酒店'},
        {'Query': '私家甜品', 'City': '重庆', 'Answer': '蜀中糖门私家甜品（磁器口店）'},
        {'Query': '牛肉面', 'City': '广州', 'Answer': '兰州牛肉面（滘口店）'},
        {'Query': '妇婴医院', 'City': '北京', 'Answer': '北京玛丽妇婴医院'},
        {'Query': '自助餐厅', 'City': '上海', 'Answer': '上隐水产海鲜自助餐厅'},
        {'Query': '涮羊肉', 'City': '北京', 'Answer': '老北京前后涮羊肉（西坝河店）'},
        {'Query': '龙岗 韩料', 'City': '深圳', 'Answer': '新村阁韩国料理'},
        {'Query': '美食排行榜', 'City': '上海', 'Answer': '角屋北海道烧肉专门店（百联中环店）'},
        {'Query': '日式猪排饭', 'City': '上海', 'Answer': '老乾杯（外滩本店）'},
        {'Query': '茶餐厅', 'City': '上海', 'Answer': '表叔茶餐厅（大融城店）'},
        {'Query': '儿童口腔', 'City': '武汉', 'Answer': '三叶儿童口腔'},
        {'Query': '静安区医院', 'City': '上海', 'Answer': '上海市静安区中心医院'},
        {'Query': '健身工作室', 'City': '上海', 'Answer': '中田健身工作室（浦东东明路店）'},
        {'Query': '海鲜', 'City': '上海', 'Answer': '大成活海鲜烧烤'},
        // {'Query': '亲子会所', 'City': '上海', 'Answer': 'Mini Mars 亲子会所（静安江宁路店）'},
        {'Query': '面馆', 'City': '上海', 'Answer': '裕兴记面馆（南京西路店）'},
        {'Query': '美容院', 'City': '北京', 'Answer': '自然美（广安门店）'},
        {'Query': '舞蹈工作室', 'City': '成都', 'Answer': 'Rich Dance（春熙店）'},
        {'Query': '江浙菜排行', 'City': '上海', 'Answer': '荣小馆（安达仕店）'},
        {'Query': '日式拉面', 'City': '上海', 'Answer': '大卫伊东日式拉面（中山公园店）'},
        {'Query': '旋转餐厅', 'City': '北京', 'Answer': '北京国际饭店星光汇旋转餐厅'},
        {'Query': '电动车', 'City': '北京', 'Answer': '小牛电动车体验店'},
        {'Query': '惠南镇美食', 'City': '上海', 'Answer': '海盗兄弟港式打边炉（惠南店）'},
        {'Query': '郊野公园', 'City': '上海', 'Answer': '浦江郊野公园'},
        {'Query': '吾悦广场', 'City': '南京', 'Answer': '江南里（吾悦广场店）'},
        {'Query': '涮肉', 'City': '北京', 'Answer': '老北京涮肉（旧鼓楼店）'},
        {'Query': '哈蜜路', 'City': '上海', 'Answer': '好宴世家（虹桥店）'},
        {'Query': '游戏机室', 'City': '上海', 'Answer': '烈火游戏机'},
        {'Query': '南京三条巷附近茶楼', 'City': '南京', 'Answer': '禅茶 TEA（金鹰店）'},
        {'Query': '南滨路美食', 'City': '重庆', 'Answer': '99会馆'},
        {'Query': '西溪天堂商业街美食', 'City': '杭州', 'Answer': '觅Q凉皮（栖悦城店）'},
        {'Query': '淮海路 ktv', 'City': '上海', 'Answer': 'INLOVE爱上银乐迪（淮海路店）'},
        {'Query': '成人蹦床 新奥购物中心', 'City': '北京', 'Answer': 'vfly蹦床公园（斯普瑞斯奥特莱斯店）'},
        {'Query': '眼镜店附近', 'City': '北京', 'Answer': 'BOLON（北京华联店）'},
        {'Query': '北宫门美食', 'City': '北京', 'Answer': '北华涮肉小院（西苑店）'},
        {'Query': '陆家嘴 意大利菜', 'City': '上海', 'Answer': '四季酒店Camelia'},
        {'Query': '咖啡厅', 'City': '北京', 'Answer': 'COSTA COFFEE（首地大峡谷2店）'},
        {'Query': '日式烤肉', 'City': '北京', 'Answer': '伙伴日式烤肉'},
        {'Query': '大兴野生动物园', 'City': '北京', 'Answer': '北京野生动物园'},
        {'Query': '宠物医院', 'City': '广州', 'Answer': '福懋动物医院（江南西店）'},
        {'Query': '炭火蛙锅', 'City': '北京', 'Answer': '巴四老城区炭火蛙锅（欧美汇店）'},
        {'Query': '儿童探索馆', 'City': '北京', 'Answer': '米蒂跳儿童主题乐园（枫蓝国际购物中心店）'},
        {'Query': '长宁区美食', 'City': '北京', 'Answer': '宝岛眼镜（北京新华百货店）'},
        {'Query': '肉骨茶', 'City': '广州', 'Answer': '大头虾越式风味（光明广场店）'},
        {'Query': '畜牧养殖场', 'City': '天津', 'Answer': '农人庄绿色蔬菜'},
        {'Query': '儿童卡丁车', 'City': '重庆', 'Answer': '莱恩儿童卡丁车俱乐部'},
        {'Query': '白云山索道门票', 'City': '广州', 'Answer': '白云山三特极限运动中心游乐园'},
        {'Query': '花园酒店', 'City': '上海', 'Answer': '上海中谷小南国花园酒店'},
        {'Query': '保育院', 'City': '天津', 'Answer': '天津市和平保育院'},
        {'Query': '朝阳大悦城 咖啡', 'City': '北京', 'Answer': '山下C5cafe'},
        {'Query': '出入境管理', 'City': '北京', 'Answer': '朝阳区出入境大厅'},
        {'Query': '公证处', 'City': '上海', 'Answer': '出入境服务中心营业部（闸北区签证中心）'},
        {'Query': '24小时药店', 'City': '杭州', 'Answer': '九洲大药房（九莲新村店）'},
        {'Query': '江边全景餐厅', 'City': '上海', 'Answer': '东方渔人码头'},
        {'Query': '朗御网红店', 'City': '成都', 'Answer': '11ROOMS拾壹间艺术展X美拍馆'}
    ],
    '1114': [
        {'Query': '宝地广场美食', 'City': '上海', 'Answer': '上海小南国（宝地店）'},
        {'Query': '威海路面馆', 'City': '上海', 'Answer': '裕兴记面馆（南京西路店）'},
        {'Query': '泡馍', 'City': '西安', 'Answer': '泥波南院门葫芦头'},
        {'Query': '提拉米苏', 'City': '上海', 'Answer': 'ORO意大利提拉米苏'},
        {'Query': '外滩中餐厅', 'City': '上海', 'Answer': '皇朝会'},
        {'Query': '富力海珠城', 'City': '广州', 'Answer': '喜茶（富力海珠城热麦店）'},
        {'Query': '香香鸡', 'City': '武汉', 'Answer': '1973继光香香鸡（群光广场店）'},
        {'Query': '自助烧烤', 'City': '北京', 'Answer': '上庄水库吉雨自助烧烤农庄'},
        {'Query': '火锅', 'City': '上海', 'Answer': '电台巷火锅（魔都直营店）'},
        {'Query': '烤鸭火锅', 'City': '上海', 'Answer': '京炉·北京烤鸭火锅（古美店）'},
        {'Query': '不二酸菜鱼', 'City': '上海', 'Answer': '太二酸菜鱼（美罗城店）'},
        {'Query': '日式烤肉', 'City': '广州', 'Answer': '角屋北海道烧肉专门店（永旺梦乐城店）'},
        {'Query': '香煎银鳕鱼', 'City': '上海', 'Answer': '沼津港渔市（宏伊国际广场店）'},
        {'Query': '纹眉', 'City': '北京', 'Answer': '久匠半永久纹眉（工体永利1店）'},
        {'Query': '影城', 'City': '北京', 'Answer': '活力天宝国际影城'},
        {'Query': '下午茶外滩', 'City': '上海', 'Answer': '悦榕庄·下午茶'},
        {'Query': '健身工作室', 'City': '北京', 'Answer': '一小时健身营养工作室（诚盈中心店）'},
        {'Query': '杨浦区医院', 'City': '上海', 'Answer': '杨浦区中心医院（安图分院）'},
        {'Query': '西青道美食', 'City': '天津', 'Answer': '陈记全羊汤'},
        {'Query': 'ktv 世贸天阶', 'City': '北京', 'Answer': '星聚会KTV（世贸天阶店）'},
        {'Query': '金牛区西餐', 'City': '成都', 'Answer': '雅米与苏格旅行主题西餐厅'},
        {'Query': '建国北路385号', 'City': '杭州', 'Answer': '渼树国潮沙龙'},
        {'Query': '刀削面附近', 'City': '北京', 'Answer': '牌面儿手工面条（双井家乐福店）'},
        {'Query': '香葱牛扎饼', 'City': '杭州', 'Answer': '古早萬丹（工联CC店）'},
        {'Query': '皮肤管理', 'City': '上海', 'Answer': '椿日式皮肤管理所'},
        {'Query': '动物园', 'City': '北京', 'Answer': '万达广场亲子动物乐园（槐房万达店）'},
        {'Query': '咖啡店', 'City': '广州', 'Answer': '杂咖（维家思广场店）'},
        {'Query': '张江地铁站', 'City': '上海', 'Answer': '张江高科地铁站'},
        {'Query': '烤鸭店', 'City': '北京', 'Answer': '四季民福烤鸭店（前门大栅栏店）'},
        {'Query': '室内儿童游乐场 长宁区', 'City': '上海', 'Answer': '多多淘（长宁来福士广场店）'},
        {'Query': '海洋公园', 'City': '上海', 'Answer': '上海海昌海洋公园'},
        {'Query': '万寿路附近', 'City': '北京', 'Answer': '湘水之珠（万寿路店）'},
        {'Query': '医药商店', 'City': '上海', 'Answer': '上海市第一医药商店（南京东路店）'},
        {'Query': '金楠天街KTV', 'City': '成都', 'Answer': '唱吧麦颂KTV（龙湖金楠天街店）'},
        {'Query': '会议', 'City': '北京', 'Answer': '北京会议中心'},
        {'Query': '早教中心', 'City': '广州', 'Answer': '新爱婴早教（中海名都店）'},
        {'Query': '密室逃脱', 'City': '西安', 'Answer': '机械师超级密室（万象城店）'},
        {'Query': '胶州路699号', 'City': '上海', 'Answer': '恒森广场'},
        {'Query': '激光美白牙齿', 'City': '北京', 'Answer': 'DISCOVER AROMA SALON&SPA'},
        {'Query': '螺蛳粉', 'City': '北京', 'Answer': '韦记螺蛳粉'},
        {'Query': '金科路长泰广场', 'City': '上海', 'Answer': '盒马鲜生（长泰店）'},
        {'Query': '面条排行榜', 'City': '南京', 'Answer': '刘记大肉面'},
        {'Query': '健身中心', 'City': '上海', 'Answer': '美格菲健身（华侨城店）'},
        {'Query': '海淀黄庄附近美食', 'City': '北京', 'Answer': '和府捞面（新中关店）'},
        {'Query': '东湖樱花园', 'City': '武汉', 'Answer': '东湖磨山樱花园'},
        {'Query': '森林公园', 'City': '上海', 'Answer': '上海海湾国家森林公园'},
        {'Query': '宝宝摄影 周岁照', 'City': '武汉', 'Answer': '一影印象KIDS PHOTO儿童摄影'},
        {'Query': '衡山电影院', 'City': '上海', 'Answer': 'SFC上影影城（新衡山店）'},
        {'Query': '唐镇阳光天地', 'City': '上海', 'Answer': '馬雅人探险乐园'},
        {'Query': '烤牛肉', 'City': '北京', 'Answer': '聚十三地摊烤牛肉'},
        {'Query': '茶餐厅', 'City': '广州', 'Answer': '好彩港式茶餐厅（时代商业店）'},
        {'Query': '湘菜', 'City': '重庆', 'Answer': '云梦庭古法湘菜（星光68店）'},
        {'Query': '下午茶网红店', 'City': '上海', 'Answer': '看得到风景的天台'},
        {'Query': '奥城 大盘鸡', 'City': '天津', 'Answer': '阿依来新疆餐厅（奥城店）'},
        {'Query': '波西米亚狂想曲', 'City': '上海', 'Answer': '中影国线影城（徐汇虹梅广场店）'},
        {'Query': '江桥万达  山西面馆', 'City': '上海', 'Answer': '老金老汤面'},
        {'Query': '剑川路布艺', 'City': '上海', 'Answer': '菁越窗帘'},
        {'Query': '1979文化新天地美食', 'City': '深圳', 'Answer': '悠然小馆私房菜-茶馆（棋牌）'},
        {'Query': '顺义区月子护理', 'City': '北京', 'Answer': '悦膳月善月子餐'},
        {'Query': '置汇旭辉广场美食', 'City': '上海', 'Answer': '摩罗厨房（LCM置汇旭辉广场店）'},
        {'Query': '花园路附近美食', 'City': '北京', 'Answer': '海碗居北京菜（牡丹园店）'},
        {'Query': '葵花公寓 日料', 'City': '深圳', 'Answer': '植藤·匠日本料理'},
        {'Query': '五号停机坪练车', 'City': '广州', 'Answer': '越秀驾校（五号机坪店）'},
        {'Query': '佘山 住宿', 'City': '上海', 'Answer': 'Homelike友家别墅轰趴派对聚会'},
        {'Query': '酒店', 'City': '成都', 'Answer': '成都金府华美达大酒店'},
        {'Query': '萝岗万达广场', 'City': '广州', 'Answer': '九龙茶室（萝岗万达店）'},
        {'Query': '口腔诊所', 'City': '上海', 'Answer': '陈真口腔诊所'},
        {'Query': '酒店', 'City': '成都', 'Answer': '成都东芮龙熙酒店（原波尔菲特酒店）'},
        {'Query': '火锅店', 'City': '上海', 'Answer': '四川香天下火锅（唐镇店）'},
        {'Query': '西安网红中餐厅', 'City': '西安', 'Answer': '淮扬府·游园京梦（SKP店）'},
        {'Query': '农家院', 'City': '北京', 'Answer': '十渡顺风别墅Hello Kitty农家院'},
        {'Query': '日本料理自助', 'City': '上海', 'Answer': '竹若荣越（人民广场店）'},
        {'Query': '日式火锅', 'City': '北京', 'Answer': '旬野菜·和牛火锅·放题（东方广场店）'},
        {'Query': '原味陕菜', 'City': '西安', 'Answer': '长安壹号'},
        {'Query': '三里屯餐馆', 'City': '北京', 'Answer': '日进·一片海（三里屯总店）'},
        {'Query': '音乐学院', 'City': '成都', 'Answer': '格音致乐音乐学院（双楠店）'},
        {'Query': '正骨', 'City': '上海', 'Answer': '陈医师推拿整脊正骨工作室（南京西路店）'},
        {'Query': '日本拉面排名', 'City': '北京', 'Answer': '武神家（新源西里店）'},
        {'Query': '海鲜酒家', 'City': '广州', 'Answer': '鸿星海鲜酒家（天河店）'},
        {'Query': '日本料理', 'City': '上海', 'Answer': '万岛日本料理铁板烧（吴中店）'},
        {'Query': '披萨', 'City': '天津', 'Answer': '美闻比萨（西湖道店）'},
        {'Query': '幼儿园', 'City': '南京', 'Answer': '伊顿慧智幼儿园'},
        {'Query': '私房料理', 'City': '上海', 'Answer': '巷语私房料理'},
        {'Query': '麻辣烫', 'City': '深圳', 'Answer': '班花麻辣烫（十亩地校区店）'},
        {'Query': '大悦城修表', 'City': '北京', 'Answer': '亨得利名表维修'},
        {'Query': '光华国际美食', 'City': '北京', 'Answer': '麦麦烧麦（远洋光华国际店）'},
        {'Query': '植物园', 'City': '广州', 'Answer': '华南植物园-售票处'},
        {'Query': '崇文门美食', 'City': '北京', 'Answer': '黄应才麻辣烫串串香'},
        {'Query': '新天地美食', 'City': '上海', 'Answer': 'The Pump 樂汸（新天地店）'},
        {'Query': '烤鸭店', 'City': '北京', 'Answer': '龙凤烤鸭店'},
        {'Query': '木樨地附近美食', 'City': '北京', 'Answer': '极地边城·云南乡土菜（月坛店）'},
        {'Query': '小学辅导', 'City': '上海', 'Answer': '睿思学习中心'},
        {'Query': '大融城美食自助餐', 'City': '上海', 'Answer': '吉布鲁海鲜自助（静安大融城店）'},
        {'Query': '老火锅', 'City': '成都', 'Answer': '二龙转老火锅（光明路店）'},
        {'Query': '手部基础护理', 'City': '上海', 'Answer': 'lulu美甲美睫沙龙'},
        {'Query': '结婚纪念日', 'City': '北京', 'Answer': '福楼毕斯罗F.Bistronome（国贸商城店）'},
        {'Query': '钟点工家政做饭', 'City': '上海', 'Answer': '猎程家政'},
        {'Query': '上海长虹医疗', 'City': '北京', 'Answer': 'FILORGA菲洛嘉医学抗衰老中心（中骏世界城店）'},
        {'Query': 'spa', 'City': '北京', 'Answer': '隐逸SPA（世纪城店）'},
        {'Query': '幼儿园', 'City': '天津', 'Answer': '华夏未来泰达城幼儿园'}
    ],
    '1418': [
        {'Query': '形象造型', 'City': '南京', 'Answer': 'MAJOR麦哲形象造型（金鹰店）'},
        {'Query': '串串', 'City': '西安', 'Answer': '洪七公吃串串（小南门店）'},
        {'Query': '美邻汇美食', 'City': '重庆', 'Answer': '守柴炉烤鸭（金科美邻汇店）'},
        {'Query': '张江 生蚝', 'City': '上海', 'Answer': '四海蚝情'},
        {'Query': '灵隐寺附近宾馆', 'City': '杭州', 'Answer': '木兰道青年旅舍（灵隐店）'},
        {'Query': '七宝万科美食', 'City': '上海', 'Answer': '汉来轩（七宝万科广场店）'},
        {'Query': '小龙虾', 'City': '深圳', 'Answer': '松哥油焖大虾（皇岗一店）'},
        {'Query': '德国大肘子', 'City': '北京', 'Answer': '福慕德国啤酒餐厅'},
        {'Query': '海岸城美食', 'City': '深圳', 'Answer': '司芳糯米（海岸城店）'},
        {'Query': '自助餐', 'City': '深圳', 'Answer': '华侨城洲际大酒店·Mercado广场咖啡厅'},
        {'Query': '儿童口腔', 'City': '杭州', 'Answer': '三叶儿童口腔（西湖诊所）'},
        {'Query': '蝴蝶酥', 'City': '上海', 'Answer': '国际饭店·西饼屋（黄河路店）'},
        {'Query': '小酒馆', 'City': '南京', 'Answer': '花千醉小酒馆（玄武湖店）'},
        {'Query': '南京南站美食', 'City': '南京', 'Answer': '南京南站'},
        {'Query': '附近银行', 'City': '上海', 'Answer': '交通银行（市西支行）'},
        {'Query': '火锅', 'City': '重庆', 'Answer': '江上火锅城（南滨路店）'},
        {'Query': '花园道美食', 'City': '武汉', 'Answer': '青瓦炭韩潮烤肉（花园道店）'},
        {'Query': '黄牛肉', 'City': '成都', 'Answer': '拈签一笑黄牛肉辣卤串串香'},
        {'Query': '普陀区长寿路818弄', 'City': '上海', 'Answer': '耳逸采耳'},
        {'Query': '静安区酒店', 'City': '上海', 'Answer': '上海寰星酒店'},
        {'Query': '自助ktv', 'City': '北京', 'Answer': '秘宅日料KTV（马甸桥店）'},
        {'Query': '美食曹家渡', 'City': '上海', 'Answer': 'CRAZYONES克芮旺斯西班牙海鲜饭（悦达889店）'},
        {'Query': '大学路美食', 'City': '上海', 'Answer': '无二孃不成都（大学路店）'},
        {'Query': '甜品diy', 'City': '上海', 'Answer': 'RAINBOW DREAM原创手工生活馆'},
        // {'Query': 'spa养生会所', 'City': '南京', 'Answer': '丹妮美容SPA会所（花家桥店）'},
        {'Query': '大饼油条', 'City': '上海', 'Answer': '健康夜市大饼油条（定西路店）'},
        {'Query': '儿童摄影周岁照', 'City': '北京', 'Answer': '小鬼当佳儿童摄影（西红门店）'},
        {'Query': '照相馆', 'City': '广州', 'Answer': '海豚家族照相馆（天河北店）'},
        {'Query': '和平大悦城美食', 'City': '天津', 'Answer': '九龍冰室'},
        {'Query': '运动健身', 'City': '上海', 'Answer': '乐刻运动健身（华庆商务楼店）'},
        {'Query': '珠江新城美食', 'City': '广州', 'Answer': '奈雪の茶（花城汇南店）'},
        {'Query': '棒棒鸡', 'City': '上海', 'Answer': '廖记棒棒鸡（天山百盛店）'},
        {'Query': '巧克力蛋糕', 'City': '西安', 'Answer': '古早味'},
        {'Query': '复印店打印', 'City': '上海', 'Answer': '蔚文印刷'},
        {'Query': '蛇口港咖啡店', 'City': '深圳', 'Answer': 'Akimbo Cafe'},
        {'Query': '回龙观东大街', 'City': '北京', 'Answer': '巫山烤全鱼（麻辣香锅）'},
        {'Query': '陕西特色面馆', 'City': '南京', 'Answer': '秦味居陕西特色面馆'},
        {'Query': '宝宝游泳馆', 'City': '深圳', 'Answer': '小龙宫恒温游泳馆（横岗店）'},
        {'Query': '武大郎烧饼', 'City': '北京', 'Answer': '三义和酒楼（广渠门店）'},
        {'Query': '串串香', 'City': '深圳', 'Answer': '钢管厂五区小郡肝串串香（卓越店）'},
        {'Query': '实景密室', 'City': '重庆', 'Answer': '灰渡真人实景密室（观音桥总店）'},
        {'Query': '粥', 'City': '天津', 'Answer': '粥story粥故事（天河城店）'},
        {'Query': '虹口龙之梦', 'City': '上海', 'Answer': '鮨士道寿司（龙之梦购物中心虹口店）'},
        {'Query': '武林路9号', 'City': '杭州', 'Answer': '艳台湾火锅'},
        {'Query': '茶饭', 'City': '西安', 'Answer': '花里·日常茶饭（金辉国际广场店）'},
        {'Query': '麻辣烫', 'City': '北京', 'Answer': '张亮麻辣烫 百子湾'},
        {'Query': '修手机上门', 'City': '北京', 'Answer': '闪修侠（朝阳店）'},
        {'Query': '宠物咖啡厅', 'City': '上海', 'Answer': '念柴宠物狗狗主题咖啡厅'},
        {'Query': ' 保洁清洗', 'City': '北京', 'Answer': '番茄管家（通州店）'},
        {'Query': '椒麻鸡', 'City': '北京', 'Answer': '椒鸣椒麻小馆（五道口店）'},
        {'Query': '蟹', 'City': '上海', 'Answer': '成隆行蟹王府（淮海店）'},
        {'Query': '芳草地', 'City': '北京', 'Answer': '侨福芳草地购物中心'},
        {'Query': '海鲜火锅', 'City': '成都', 'Answer': '集渔·泰式海鲜火锅（光华中坝店）'},
        {'Query': '万胜围保利广场', 'City': '广州', 'Answer': '澳佳利航空主题餐厅'},
        {'Query': '老鸭粉丝汤', 'City': '上海', 'Answer': '妯娌老鸭粉丝汤'},
        // {'Query': '养生会所', 'City': '武汉', 'Answer': '0577养生会所（石牌岭店）'},
        {'Query': '老火锅', 'City': '上海', 'Answer': '小龍坎老火锅（百联南方购物中心店）'},
        {'Query': '美容院', 'City': '广州', 'Answer': 'AstenBeauty天俪美国际美容美甲'},
        {'Query': '美罗城美食', 'City': '上海', 'Answer': '虫二酒肆（美罗城店）'},
        {'Query': '静安面包房', 'City': '上海', 'Answer': '静安面包房（福州店）'},
        {'Query': '酒店', 'City': '上海', 'Answer': '上海宝格丽酒店'},
        {'Query': '五角场美食', 'City': '上海', 'Answer': '新白鹿餐厅（悠迈生活广场店）'},
        {'Query': '日料排行榜', 'City': '上海', 'Answer': '鮨匠Artisan（漫游城店）'},
        {'Query': '欣阳广场店', 'City': '重庆', 'Answer': '老厂长老火锅（欣阳广场店）'},
        {'Query': '健身房附近', 'City': '武汉', 'Answer': '凯菲特健身'},
        {'Query': '照相馆', 'City': '上海', 'Answer': '方快-照相馆（近铁城市广场店）'},
        {'Query': '自助餐晚餐', 'City': '广州', 'Answer': '西堤厚牛排（广州五月花广场店）'},
        {'Query': '西装 ', 'City': '上海', 'Answer': 'SHARMOON.EZ高级西服定制'},
        {'Query': '万象城美食', 'City': '重庆', 'Answer': '奈九居酒屋（万象城店）'},
        {'Query': '九方购物中心', 'City': '深圳', 'Answer': '星洲椰场·椰子鸡火锅（华强北九方店）'},
        {'Query': '江南西网红店', 'City': '广州', 'Answer': '大葱柠檬茶scallionlemontea（江南西店）'},
        {'Query': '空港新天地', 'City': '杭州', 'Answer': '美滋滋烤鱼（空港新天地店）'},
        {'Query': '椰子鸡', 'City': '深圳', 'Answer': '润园四季椰子鸡（卓悦汇店）'},
        {'Query': '咖啡', 'City': '上海', 'Answer': '太平洋咖啡（世纪金融广场店）'},
        {'Query': '长宁来福士', 'City': '上海', 'Answer': '湊湊火锅·茶憩（来福士广场长宁店）'},
        {'Query': '高压锅生蚝', 'City': '杭州', 'Answer': '一锹鲜（下沙自游港店）'},
        {'Query': 'diy饼干', 'City': '北京', 'Answer': '小熊烘焙DIY（西单店）'},
        {'Query': '蒸蛋糕', 'City': '上海', 'Answer': '港荣蒸蛋糕'},
        {'Query': '本帮菜', 'City': '上海', 'Answer': '三林本帮馆（中林街店）'},
        {'Query': '茶餐厅', 'City': '上海', 'Answer': '新马茶餐厅（189弄购物中心店）'},
        {'Query': '蛙鱼头', 'City': '成都', 'Answer': '鼎味美蛙鱼头（兆景路店）'},
        {'Query': '儿童游泳馆', 'City': '天津', 'Answer': '乐康.水木天成游泳馆'},
        {'Query': '纪念日蛋糕', 'City': '深圳', 'Answer': '锦祺花芬鲜花（嘉葆店）'},
        {'Query': '足球俱乐部', 'City': '天津', 'Answer': '斯巴达足球俱乐部'},
        {'Query': '九宫格火锅', 'City': '成都', 'Answer': '李子坝九宫格火锅'},
        {'Query': '长寿路 面包', 'City': '上海', 'Answer': 'HONEYEAST 蜂酿软欧面包（西康店）'},
        {'Query': '奶酪比萨饼', 'City': '上海', 'Answer': 'Homeslice Pizza（中山公园店）'},
        {'Query': '二手办公家具', 'City': '深圳', 'Answer': '方生新家私店'},
        {'Query': 'diy手工坊', 'City': '北京', 'Answer': '唯美刻DIY蛋糕店'},
        {'Query': '音乐火锅', 'City': '上海', 'Answer': '好乐迪音乐火锅'},
        {'Query': '上海体育馆酒吧', 'City': '上海', 'Answer': 'LUCKY BAR（漕溪北路店）'},
        {'Query': '瑞金路熏鱼', 'City': '南京', 'Answer': '闵记熏鱼'},
        {'Query': '王府井美食', 'City': '北京', 'Answer': '小吊梨汤（王府井银泰店）'},
        {'Query': '手工吐司', 'City': '北京', 'Answer': '爸爸糖手工吐司'},
        {'Query': '广场美食', 'City': '上海', 'Answer': '甲壮元（好爱广场店）'},
        {'Query': '太古里 咖啡', 'City': '成都', 'Answer': 'DENHAM × UID CAFE（太古里店）'},
        {'Query': '牛排', 'City': '武汉', 'Answer': '西堤厚牛排（群光广场店）'},
        {'Query': '眼镜店  紫峰', 'City': '南京', 'Answer': 'Lilywit眼镜定制（紫峰购物中心店）'},
        {'Query': '4s店', 'City': '上海', 'Answer': '上海普陀宝泓宝马4S店（梅川路店）'},
        {'Query': '电影院', 'City': '北京', 'Answer': '首都电影院（西单店）'}
    ],
    '1809': [
        {'Query': '生日自助餐', 'City': '上海', 'Answer': 'AdD全日制餐厅（中谷小南国花园酒店店）'},
        {'Query': '针灸腰肌劳损', 'City': '上海', 'Answer': '康陌脊柱整复中心'},
        {'Query': 'holiday inn', 'City': '杭州', 'Answer': '杭州萧山众安假日酒店'},
        {'Query': '烤面筋', 'City': '南京', 'Answer': '黄记绝味烤面筋（大厂店）'},
        {'Query': '自助餐海鲜', 'City': '上海', 'Answer': '两咖啡自助餐厅（静安香格里拉大酒店）'},
        {'Query': '博瑞大厦美食', 'City': '北京', 'Answer': '秦宝雪花牛肉（高和萃东三环北路店）'},
        {'Query': '老门东1345', 'City': '南京', 'Answer': '1345汗蒸温泉会馆'},
        {'Query': '菜包', 'City': '上海', 'Answer': '绿杨邨酒家外卖部'},
        // {'Query': '桑拿会所', 'City': '上海', 'Answer': '纽斯桑拿会所（金汇南路店）'},
        {'Query': '华联力宝购物中心', 'City': '北京', 'Answer': '鹿谷制茶（亦庄店）'},
        {'Query': '麻辣香锅', 'City': '杭州', 'Answer': '汉库麻辣香锅（紫金港店）'},
        {'Query': '西直门凯德mall', 'City': '北京', 'Answer': '凯德MALL（西直门店）'},
        {'Query': '密室逃脱江汉路', 'City': '武汉', 'Answer': 'YOGO优果真人密室逃脱（江汉路店）'},
        {'Query': '紫峰自助餐', 'City': '南京', 'Answer': '绿地洲际酒店·粤翠轩'},
        {'Query': '欢乐海岸美食', 'City': '深圳', 'Answer': 'CJW酒吧 Cigar Jazz Wine'},
        {'Query': '火锅', 'City': '南京', 'Answer': '陈记一牛火锅（清江苏宁店）'},
        {'Query': '羊肉馆', 'City': '上海', 'Answer': '李记羊肉（民宿店）'},
        {'Query': '安顺路麻辣烫', 'City': '上海', 'Answer': '重庆奔吃麻辣烫（安顺路店）'},
        {'Query': '金陵东路便利店', 'City': '上海', 'Answer': '好德便利（金陵店）'},
        {'Query': '美发沙龙', 'City': '深圳', 'Answer': 'TONI&GUY美发沙龙（深圳湾万象城店）'},
        {'Query': '烧烤', 'City': '杭州', 'Answer': '大清谷半日闲户外烧烤'},
        {'Query': '图文快印中心', 'City': '天津', 'Answer': '博恒睿彩数码图文快印中心'},
        {'Query': '未来广场', 'City': '天津', 'Answer': '新煮意（天津远洋未来广场店）'},
        {'Query': '凉拌饺子皮', 'City': '西安', 'Answer': '长安大牌档之长安集市（赛格国际购物中心店）'},
        {'Query': '雷峰塔美食', 'City': '杭州', 'Answer': '杭州土菜馆'},
        {'Query': '煲仔饭', 'City': '广州', 'Answer': '民记煲仔饭'},
        {'Query': '龙虾馆', 'City': '广州', 'Answer': '文和友龙虾馆（北京路旗舰店）'},
        {'Query': ' 美甲', 'City': '上海', 'Answer': 'Miss Gao 美甲'},
        {'Query': '照相馆', 'City': '上海', 'Answer': '优行相照相馆'},
        {'Query': '美颜', 'City': '北京', 'Answer': 'UP&UP半永久定妆 纹绣纹眉纹眼线（三里屯店）'},
        {'Query': '西安饭庄', 'City': '西安', 'Answer': '西安饭庄（凤城五路店）'},
        {'Query': '川菜排行榜', 'City': '成都', 'Answer': '隐庐·古法川菜'},
        {'Query': '虎坊桥 烤肉', 'City': '北京', 'Answer': '刘记炙子烤肉（虎坊桥店）'},
        {'Query': '延安西路1228', 'City': '上海', 'Answer': '讲究涮肉馆'},
        {'Query': '土菜馆', 'City': '上海', 'Answer': '寿州土菜馆'},
        {'Query': '高新区法国餐厅', 'City': '成都', 'Answer': '翠玲珑CUI'},
        {'Query': '泰晤士小镇美食', 'City': '上海', 'Answer': '艾邑庭'},
        {'Query': '全家福拍照', 'City': '北京', 'Answer': '小卷毛·儿童亲子摄影馆'},
        {'Query': '天河区美食', 'City': '广州', 'Answer': '茶煲小舍'},
        {'Query': '烘焙diy', 'City': '北京', 'Answer': '莎莉花园·插花烘焙DIY文艺小院'},
        {'Query': '酒店自助餐', 'City': '上海', 'Answer': '万豪轩中餐厅'},
        {'Query': '武林路美食', 'City': '杭州', 'Answer': '大牌大·元夕'},
        {'Query': '化龙桥九宫格', 'City': '成都', 'Answer': '化龙桥九宫格火锅'},
        {'Query': '冰淇淋布丁', 'City': '上海', 'Answer': 'Wanna Feel Restaurant&Bar 至觉西餐厅酒吧'},
        {'Query': '涮肉坊', 'City': '上海', 'Answer': '臻馆（虹井路店）'},
        {'Query': '附近的蛋糕店', 'City': '北京', 'Answer': '味多美（甘露园店）'},
        {'Query': '串串香', 'City': '北京', 'Answer': '马路边边串串香（对外经贸大学店）'},
        {'Query': '南山路酒吧', 'City': '杭州', 'Answer': '黄楼酒吧'},
        {'Query': '金融街购物中心美食', 'City': '北京', 'Answer': '炭匠（金融街购物中心店）'},
        {'Query': '装修装饰公司', 'City': '北京', 'Answer': '中艺理想家装饰旗舰店'},
        {'Query': '日本料理', 'City': '北京', 'Answer': '京樱日本料理（欧陆时尚店）'},
        {'Query': '德基广场美食', 'City': '南京', 'Answer': '翠园（德基广场店）'},
        {'Query': '杭州西湖青旅', 'City': '杭州', 'Answer': '飞鸟集酒店（杭州星光大道金铂湾店）'},
        {'Query': '美发沙龙', 'City': '深圳', 'Answer': 'TONI & GUY 美发沙龙（南山万象天地店）'},
        {'Query': '解放碑美食', 'City': '重庆', 'Answer': '八角九（解放碑店）'},
        {'Query': '汉溪长隆地铁站美食', 'City': '广州', 'Answer': '田塘里粤菜（长隆店）'},
        {'Query': 'home趴', 'City': '武汉', 'Answer': '玩bar高端聚会派对轰趴（汉口江汉路店）'},
        {'Query': '琴台路美食', 'City': '成都', 'Answer': '寿禧堂酒楼.寿宴.百日宴.宴会（琴台路店）'},
        {'Query': '牛排馆', 'City': '北京', 'Answer': '豪尚豪牛排馆（城乡世纪广场店）'},
        {'Query': '口腔医院', 'City': '北京', 'Answer': '北京大学口腔医院（第二门诊部）'},
        {'Query': '自助海鲜', 'City': '上海', 'Answer': '曼哈顿自助海鲜·精选（虹口龙之梦店）'},
        {'Query': '老外街美食', 'City': '上海', 'Answer': 'VEDAS印度餐厅（虹桥店）'},
        {'Query': '打边炉', 'City': '上海', 'Answer': '捞小灶港式打边炉（宝山店）'},
        {'Query': '养生馆', 'City': '北京', 'Answer': '振京阁养生馆'},
        {'Query': '过桥米线', 'City': '西安', 'Answer': '豐记米线'},
        {'Query': '健身工作室', 'City': '北京', 'Answer': 'COCO健身私教工作室（北洼路店）'},
        {'Query': '精致料理', 'City': '上海', 'Answer': '旨料亭精致料理（月星环球港店）'},
        {'Query': '中学', 'City': '上海', 'Answer': '星河湾中学'},
        {'Query': '烧烤 烤串', 'City': '成都', 'Answer': '灶门坎把把烧（太古里店）'},
        {'Query': '美发沙龙', 'City': '北京', 'Answer': 'TONI&GUY（太古里店）'},
        {'Query': '自助餐海鲜', 'City': '上海', 'Answer': '百合福·海鲜自助餐（百联南方购物中心店）'},
        {'Query': '海鲜自助', 'City': '天津', 'Answer': '观宴·海鲜美学主题自助餐厅'},
        {'Query': '牛排馆', 'City': '上海', 'Answer': 'Wolfgang’s Steakhouse 沃夫冈牛排馆'},
        {'Query': '烤鸭', 'City': '北京', 'Answer': '四季民福烤鸭店（东四十条店）'},
        {'Query': '寿喜烧', 'City': '上海', 'Answer': '牛New寿喜烧（五角场店）'},
        {'Query': '电动车', 'City': '南京', 'Answer': '雅迪电动车（新城市广场店）'},
        {'Query': '发廊', 'City': '广州', 'Answer': 'Kraemer Paris·苏豪发廊（恒宝广场店）'},
        {'Query': '静安寺美食', 'City': '上海', 'Answer': '谭鸭血老火锅（愚园路店）'},
        {'Query': '健身', 'City': '北京', 'Answer': '力美俊健身（月坛店）'},
        {'Query': '自助烧烤', 'City': '北京', 'Answer': '上庄水库绿水岸边自助烧烤'},
        {'Query': '会员店', 'City': '北京', 'Answer': '山姆会员商店（阜石路店）'},
        {'Query': '烧鸡', 'City': '深圳', 'Answer': '云记荔枝柴烧鸡音乐餐吧'},
        {'Query': '烤肉', 'City': '上海', 'Answer': '杨记齐齐哈尔烤肉（真如店）'},
        {'Query': '修脚房', 'City': '武汉', 'Answer': '郑远元专业修脚房'},
        {'Query': '购物中心', 'City': '西安', 'Answer': '西市城购物中心'},
        {'Query': '日式烧烤自助', 'City': '上海', 'Answer': '薪火烧肉源之屋（第一百货店）'},
        {'Query': '艺术学校', 'City': '北京', 'Answer': '毛戈平形象设计艺术学校'},
        {'Query': '糖水铺', 'City': '上海', 'Answer': '香港華心糖水鋪'},
        {'Query': '豆浆夜市', 'City': '广州', 'Answer': '路边等你·豆浆夜市'},
        {'Query': '水疗馆', 'City': '上海', 'Answer': '御府泉水疗馆'},
        {'Query': '浦东机场t2航站楼美食', 'City': '上海', 'Answer': '谷田稻香（浦东机场店）'},
        {'Query': '完美证件照', 'City': '西安', 'Answer': '不二公社の照相馆（小寨旗舰店）'},
        {'Query': '三里屯美食', 'City': '北京', 'Answer': '安妮意大利餐厅（三里屯店）'},
        {'Query': '酸菜鱼', 'City': '上海', 'Answer': '川承我家酸菜鱼'},
        {'Query': '嘉年华', 'City': '北京', 'Answer': '空气湃运动嘉年华'},
        {'Query': '公园', 'City': '上海', 'Answer': '顾村公园'},
        {'Query': '迪斯尼小镇美食', 'City': '上海', 'Answer': '正好鱼见你（迪士尼店）'},
        {'Query': '私教工作室', 'City': '南京', 'Answer': 'BBC大型健身搏击私教工作室（新街口店）'},
        {'Query': '上海火车站南广场美食', 'City': '上海', 'Answer': '壹小馆·皇城老妈小火锅（凯德星贸店）'},
        {'Query': '音乐酒馆', 'City': '广州', 'Answer': '胡桃里音乐酒馆（海珠赤岗店）'}
    ]
};
